import { useContext } from "react"
import { SurveyContentTypeContext } from "./SurveyContentTypeContext"
import { SurveyContentType } from "models/generated"

export const useSurveyContentType = () => {
  const context = useContext(SurveyContentTypeContext)

  if (context === undefined) {
    throw new Error("Survey content type not specified")
  }

  return {
    isLeaSurvey: context === SurveyContentType.Lea,
    isSpeakupSurvey: context === SurveyContentType.Speakup,
    surveyContentType: context,
  }
}
